import styled from 'styled-components'


export const AccordionSection = styled.div`
    display: flex;
    flex-direction: column;
`;
export const AccordionTitle = styled.p`
    font-family: 'Avenir';
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 46px;
    color: #090458;
    @media screen and (max-width: 768px) {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #090458;
    }

`;
export const AccordionContent = styled.div`
    background-color: white;
    overflow: hidden;
    transition: max-height 0.6s ease;
`;
export const AccordionText = styled.div`
    padding: 18px;
    font-family: 'Avenir';
    font-style: normal;
    font-weight: 400;
    font-size: 19px;
    line-height: 31px;
    letter-spacing: 0.01em;
    color: #8D8D8D;
    padding-left:50px;
    @media screen and (max-width: 768px) {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        padding-left:30px;

    }
`;
export const ToggleIcon = styled.span`
    padding: 18px;
    font-weight: 400;
    font-size: 30px;
    @media screen and (max-width: 768px) {
        font-weight: 400;
        font-size: 18px;
     
    }
`;
